import * as filterByYear from "../../../_src/components/filter/years"

if (document.querySelector(".filter-menu")) {
    filterByYear.filterFilesByYears()
}
